export class SupplierMaster {
  id: number;
  fsc: string;
  fedexSupplierNumber: string;
  companyName: string;
  auditNameKey: string;
  activateTime: Date;
  expireTime: Date;
  supplierStation: string;
  supplierDepartment: string;
  callBackDate: Date;
  auditInfoRequired: string;
  lastPoDate: Date;
  lastSoDate: Date;
  sitaCode: string;
  airAgencyCertificate: string;
  fobPoint: string;
  supplierTerms: string;
  minorityIndicator: string;
  auditCycle: number;
  auditor: string;
  auditSection: number;
  lastAuditDate: Date;
  nextAuditDate: Date;
  caseId: string;
  caseAirline: string;
  caseAuditDate: Date;
  requestNumber: number;
  aogAddedIndicator: string;
  apRemitTo: string;
  apVendorEditCode: string;
  aogTextKey: number;
  qaTextKey: number;
  supplierTextKey: number;
  shippingInstructionsKey: string;
  aogUsageCount: number;
  qaAuditNeeded: string;
  aogStation: string;
  lastUsedDate: Date;
  caseInfoIndicator: string;
  receivePoSoIndicator: string;
  drugAgencyNumber: string;
  poEdiXmtMethod: string;
  poEditFormat: string;
  soEditXmtMethod: string;
  soEditFormat: string;
  ediFdxnetAddress: string;
  poEdiEmailAddress: string;
  soEdiEmailAddress: string;
  poEdiFaxNumber: string;
  soEdiFaxNumber: string;
  poEdiContact: string;
  poEdiContactPhone: string;
  poEdiContactExtension: number;
  soEdiContact: string;
  soEdiContactPhone: string;
  spEdiContactExtension: number;
  bypassAogUsage: string;
  bypassInactive: string;
  soSitaCode: string;
  soEdiFdxnetAddress: string;
  smsContactUserId: string;
  poAvisoIndicator: string;
  soAvisoIndicator: string;
  vendorTaxId: string;
  inboundShiprule: string;
  psaaWarrantyFlag: string;
  poCompanyName1: string;
  poCompanyName2: string;
  poAddressLine1: string;
  poAddressLine2: string;
  poCity: string;
  poState: string;
  poZipCode: string;
  poCountryCode: string;
  poPhoneNumber: string;
  poPhoneExtension: string;
  poFaxNumber: string;
  poContactPerson: string;
  poEmailAddress: string;
  poValid: number;
  soCompanyName1: string;
  soCompanyName2: string;
  soAddressLine1: string;
  soAddressLine2: string;
  soCity: string;
  soState: string;
  soZipCode: string;
  soCountryCode: string;
  soPhoneNumber: string;
  soPhoneExtension: string;
  soFaxNumber: string;
  soContactPerson: string;
  soEmailAddress: string;
  soValid: number;
  qaCompanyName1: string;
  qaCompanyName2: string;
  qaAddressLine1: string;
  qaAddressLine2: string;
  qaCity: string;
  qaState: string;
  qaZipCode: string;
  qaCountryCode: string;
  qaPhoneNumber: string;
  qaPhoneExtension: string;
  qaFaxNumber: string;
  qaContactPerson: string;
  qaEmailAddress: string;
  qaValid: number;
  aogCompanyName1: string;
  aogCompanyName2: string;
  aogAddressLine1: string;
  aogAddressLine2: string;
  aogCity: string;
  aogState: string;
  aogZipCode: string;
  aogCountryCode: string;
  aogPhoneNumber: string;
  aogPhoneExtension: string;
  aogFaxNumber: string;
  aogContactPerson: string;
  aogEmailAddress: string;
  aogValid: number;
  warrantyCompanyName1: string;
  warrantyCompanyName2: string;
  warrantyAddressLine1: string;
  warrantyAddressLine2: string;
  warrantyCity: string;
  warrantyState: string;
  warrantyZipCode: string;
  warrantyCountryCode: string;
  warrantyPhoneNumber: string;
  warrantyPhoneExtension: string;
  warrantyFaxNumber: string;
  warrantyContactPerson: string;
  warrantyEmailAddress: string;
  warrantyValid: number;
  accountingCompanyName1: string;
  accountingCompanyName2: string;
  accountingAddressLine1: string;
  accountingAddressLine2: string;
  accountingCity: string;
  accountingState: string;
  accountingZipCode: string;
  accountingCountryCode: string;
  accountingPhoneNumber: string;
  accountingPhoneExtension: string;
  accountingFaxNumber: string;
  accountingContactPerson: string;
  accountingEmailAddress: string;
  accountingValid: number;
  umbrellaCorporation: string;
  corporationType: string;
  umbrellaCorpLastModifiedBy: string;
  umbrellaCorpLastModifiedAt: string;
  umbrellaCorpSubClass: string;
  umbrellaCorpOwnersInitials: string;
  allTypeSuspendedIndicator: number;
  purchaseOrderSuspendedIndicator: number;
  serviceOrderSuspendedIndicator: number;
  nullPoSoSuspendedIndicator: number;
  allSuspendedSupplierTypes: string;
  purchaseOrderSuspendedSupplierTypes: string;
  serviceOrderSuspendedSupplierTypes: string;
  nullPoSoSuspendedSupplierTypes: string;
  }
